import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  proposalsList: { display: 'flex', flexDirection: 'column', position: 'relative', minHeight: '20rem' },
  proposalCardWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  removeButtonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '28%',
  },
  productLineSection: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '3.2rem 4rem',
    marginBottom: '3.2rem',
    '&:last-of-type': {
      marginBottom: '0rem',
    },
  },
  cartItemsContent: {
    paddingTop: '4rem',
    display: 'flex',
    flexDirection: 'column',
  },
  cartItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '3rem',
  },
  bcForm: { paddingLeft: '2rem' },
  proposalFullyLoader: {
    position: 'relative',
    minHeight: '35rem',
    width: '100%',
    border: `1px solid ${colors.neutral[400]}`,
    borderRadius: '1rem',
  },
  currentName: {
    margin: '0 0.5rem',
    color: colors.neutral[900],
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
